'use strict';

export default {
  formPublic: {
    postSubmission: {
      noRecaptcha: "Aucun token recaptcha n'a été envoyé au serveur",
      invalidRecaptcha: 'Le token recaptcha est invalide. Veuillez réessayer',
      genericDecline: 'Échec de paiement. Veuillez réessayer plus tard',
      insufficientFunds: 'Échec de paiement pour fonds insuffisants',
      lostCard: 'Échec de paiement pour cause de carte déclarée perdue',
      stolenCard: 'Échec de paiement pour carte déclarée volée',
      expiredCard: 'Échec de paiement pour carte expirée',
      incorrectCVC: 'Échec de paiement pour code CVC incorrect',
      processingError: 'Échec de paiement pour erreur de traitement',
      incorrectNumber: 'Échec de paiement pour numéro de carte incorrect',
      missingEmail: 'Courriel invalide/manquant pour le reçu de formulaire',
      missingName: 'Titulaire de la carte manquant',
      genericError: 'Une erreur est survenue',
      limitError: 'Une limite de produit a été atteinte, veuillez réessayer',
      inactiveFormError: "Le formulaire est inactif. Veuillez contacter l'organisation.",
      incorrectDiscount:
        "Une erreur s'est produite avec le code rabais. Il est peut-être expiré ou la limite a été atteinte. Il a été retiré. Veuillez réessayer.",
    },
    badges: {
      succeeded: 'Accepté',
      pending: 'En attente',
      failed: 'Échoué',
      processing: 'En traitement',
      canceled: 'Annulé',
      requiresAction: 'Requiert action',
      requiresConfirmation: 'Requiert confirmation',
      requiresPaymentMethod: 'Méthode de paiement manquante',
      refunded: 'Remboursé',
      pendingRefund: 'Remboursement en traitement',
      ready: 'Planifié',
    },
    noFields: 'Aucun champs',
    submit: 'Soumettre',
    next: 'Suivant',
    previous: 'Précédent',
    optionalPayment: "Payez d'une autre façon",
    paymentPlan: 'Plan de paiement',
    paymentMethod: {
      title: 'Comment souhaitez-vous payer ?',
      creditCard: 'Carte de crédit',
      interac: 'Virement Interac',
      cheque: 'Chèque',
      cash: 'Comptant',
      other: 'Autre',
    },
    formFixedAmount: 'Montant fixe pour le formulaire',
    formAmountSummaryText: 'Frais de base',
    summary: 'Sommaire',
    shareForm: 'Partager ce formulaire',
    share: 'Partager',
    close: 'Fermer',
    link: 'Lien URL',
    code: 'Code HTML',
    copy: 'Copier',
    copied: 'Copié !',
    urlCopy: "Copier l'url",
    integrate: 'Intégrer',
    open: 'Ouvrir dans un onglet',
    receiptEmail: 'Courriel pour reçu de formulaire',
    cardHolderName: 'Titulaire de la carte',
    errorRefundAmount: 'Corriger le montant du remboursement avant de confirmer',
    discountCode: 'Code rabais',
    apply: 'Appliquer',
    remove: 'Supprimer',
    discountCodeApplied: `Code rabais appliqué ! Vous économisez {discount}{type, select, 
                            percent {%}
                            amount {$}  
                            other {}  
                          }.`,
    discountCodeError: 'Le code rabais est invalide. Veuillez réessayer.',
    discount: 'Rabais',
    discountCodeSummary: 'Code {code}',
  },
};
